module.exports = __webpack_public_path__ + "img/shower.9ab95b88.svg";